/**
 * @deprecated
 */
import $ from 'jquery';

$('span.reverse-email').each(function() {
  var mailTo = $(this).text().split("").reverse().join("");
  $(this).replaceWith($('<a href="mailto:'+mailTo+'">'+ mailTo + '</a>'));
});

$('.js_focus').on('focusin', function(){
  $(this).parent().addClass('is-focus');
}).on('focusout', function(){
  $(this).parent().removeClass('is-focus');
});

$('a[href$=".pdf"], a[href$=".doc"], a[href$=".docx"], a[href$=".xls"], a[href$=".xlsx"], a[href$=".ppt"], a[href$=".pptx"], a[href$=".pps"], a[href$=".zip"], a[href$=".rar"]').each(function () {
  var $thisLink = $(this);
  var fileType = "";
  var documentText = "";

  if ($(this).attr('href').indexOf('.pdf') != -1) {
    fileType = 'PDF';
  } else if ($(this).attr('href').indexOf('.doc') != -1) {
    fileType = 'DOC';
  } else if ($(this).attr('href').indexOf('.docx') != -1) {
    fileType = 'DOCX';
  } else if ($(this).attr('href').indexOf('.xls') != -1) {
    fileType = 'XLS';
  } else if ($(this).attr('href').indexOf('.xlsx') != -1) {
    fileType = 'XLSX';
  } else if ($(this).attr('href').indexOf('.ppt') != -1) {
    fileType = 'PPT';
  } else if ($(this).attr('href').indexOf('.pptx') != -1) {
    fileType = 'PPTX';
  } else if ($(this).attr('href').indexOf('.pps') != -1) {
    fileType = 'PPS';
  } else if ($(this).attr('href').indexOf('.zip') != -1) {
    fileType = 'ZIP';
  } else if ($(this).attr('href').indexOf('.rar') != -1) {
    fileType = 'RAR';
  };

  if ($thisLink.parents('.wysiwyg-container').length && fileType != "") {
    $thisLink.append(' <span class="sr-only"> ('+ fileType +')</span>');
  }
});

/*
 * !!!NECHAT NA KONCI web.js!!!
 * V hlavičce webu je JavaScript var q = []; $ = function(f) {q.push(f)};, který zajistí,
 * že kdekoli vyskytující se inline javascript bude vykonán až po načtení stránky
 * Inline JavaScript musí být vnořen do následujícího kusu kódu
 *
 * $(function(){
 *     //inline JavaScript
 * });
 *
 * který je ve skutečnosti zkrácené volání $(document).ready() @see http://learn.jquery.com/using-jquery-core/document-ready/
 * předpokládá se tedy, že na webu bude použito jQuery
 *
 * viz http://www.slideshare.net/slideshow/embed_code/17116700?startSlide=10
 * */
if (window.q) {
	window.q.forEach((f) => {
		$(f);
	});
}

$(window).scroll(function() {
	if ($(this).scrollTop() > 250) {
		$(".page-bg-top").hide();
	} else {
		$(".page-bg-top").show();
	}
});



// WEBPACK FOOTER //
// ./fe/web-default/src/js/web.js